module.exports = __webpack_public_path__ + "static/media/icon-location.1756f9a4.svg";